/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'history': {
    width: 16,
    height: 16,
    viewBox: '0 0 256 256',
    data: '<path pid="0" d="M115.6 82.8v69.8h46.5v-23.3h-23.2V82.8z"/><path pid="1" d="M127.2 13c-31.6 0-60.7 12.7-82.1 34.2L22.6 24.6v69.8h69.8L61.5 63.6c17.1-17.2 40.4-27.3 65.7-27.3 51.3 0 93.1 41.7 93.1 93.1s-41.7 93.1-93.1 93.1v23.3c64.1 0 116.3-52.2 116.3-116.3S191.4 13 127.2 13z"/>'
  }
})
